import { TabTextLabel } from "@/shared/components/ui";
import { Delete } from "@mui/icons-material";
import { Grid, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from "@mui/material";
import { BODEGAS } from "@/shared/interfaces/erp/inventario";
import { toast } from "react-toastify";
import { gridSizeMdLg6 } from "@/shared";
import ModalBodegaUsuario from "./ModalBodegaUsuario";

interface AgregarBodegaUsuarioProps {
  dataBodegas: BODEGAS[]
  setDataBodegas: React.Dispatch<React.SetStateAction<BODEGAS[]>>
}

export default function AgregarBodegaUsuario({
  dataBodegas,
  setDataBodegas
}: AgregarBodegaUsuarioProps) {



  function addBodega(data: BODEGAS) {
    const codigo = data.codigo?.trim();
    if (!codigo) return;

    setDataBodegas((prev) => {
      if (prev.some(e => e.codigo == codigo)) {
        toast.info("Bodega agregada");
        return prev;
      }
      return [...prev, data];
    });
  }

  function removeBodega(codigo: string) {
    setDataBodegas((prev) => prev.filter((b) => b.codigo !== codigo));
  }


  return (

    <Grid item
      {...gridSizeMdLg6}
      style={{
        maxHeight: '500px',
        overflow: 'auto'
      }}
    >

      <Grid container
        justifyContent={'space-between'}
        spacing={2}
      >

        <Grid item>
          <TabTextLabel
            text={'Bodega'}
            mt={0}
            pb={0}
            pl={0}
            pt={2}
          />
        </Grid>

        <Grid item>
          <ModalBodegaUsuario
            onChange={addBodega}
          />
        </Grid>

        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Acción</TableCell>
                  <TableCell>Bodega</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataBodegas.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      <IconButton
                        onClick={() => removeBodega(row.codigo)}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.nombre}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

      </Grid>

    </Grid>

  )

}